module.exports = __webpack_public_path__ + "static/media/s.cc3c6e0d.jpg";